import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Header, MoreInformation, Buttons, SelectedPoiDetails } from '../../components';
import styles from '../PoiDetails/styles';

class WaypointDetails extends React.PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Header />
        <SelectedPoiDetails />
        <section className={classes.footer__container}>
          <MoreInformation />
          <Buttons />
        </section>
      </React.Fragment>
    );
  }
}

WaypointDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WaypointDetails);
